export const aboutData = {
    title: "Who I am",
    description1: "My name's Samuel Yadav. I'm a web designer and developer based in Delhi, India",
    description2: "I am always curious to learn new technologies and I like to enhance my skills. \nA software engineer with fundamental knowledge and experience of coding, seeking opportunities to learn advanced frameworks and technologies to implement them in my day-to-day work",
    image: 2
}